import { Component, Input, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-system-logo',
  styleUrls: ['./logo.component.scss'],
  templateUrl: './logo.component.html',
})
export class LogoComponent {
  @Input() type: 'white' | 'blue' = 'blue';
  @Input() logoUrl = '/';

  constructor() {}
}

@NgModule({
  declarations: [LogoComponent],
  exports: [LogoComponent],
  imports: [RouterModule],
})
export class SystemLogoModule {}
